import urlBuilder from "./urlBuilder";
import getUmbracoEndPoint from "app/umbraco/helpers/UmbracoEndPoint";

interface CategoriesResponse {
    result: {
        [key: string]: {
            result: {
                category: {
                    primaryTitle: string;
                    productCount: number;
                }
            }
        }
    };
}

export default async (route: string): Promise<CategoriesResponse> => {
    const url = urlBuilder("/api/content/categories", { url: route });

    const response = await fetch(url.toString(),
        {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Origin": getUmbracoEndPoint(),
                "X-Request-Domain": getUmbracoEndPoint()
            },
            body: undefined
        });

    return await response.json();
};